jQuery(document).ready(function() {
	console.log("test header");

	// jQuery('a:contains("Ask a question!")').attr('aria-label', 'Ask a question!');
   	// jQuery('a .icon-yelp').parent('a').attr('aria-label', "Visit Benny's Tacos on Yelp (opens in new tab)");


	setTimeout(function(){ 

    
	jQuery('.icon-cart').attr('role', 'presentation');


	jQuery('a.full-unstyled-link[href="/pages/ski"]').attr('aria-label', 'Ski Edge page');
	jQuery('a.full-unstyled-link[href="/pages/hockey"]').attr('aria-label', 'Hockey Edge page');

  
	jQuery('.footer-block__details-content.footer-block-image.left img').attr('alt', 'MYEDGE logo with links to Skier’s Edge and Hockey Edge');


	jQuery('#Banner-template--21463335207135__video_hero_EUqCYh h1').attr('aria-level', '2');
	jQuery('footer-accordion .h4.accordion__title, .article-card__title.h3').attr('aria-level', '2');
	jQuery('footer-accordion .h4.accordion__title').attr('role', 'heading');
	jQuery('#Banner-template--21463336059103__video_hero_f9RrPN h2').attr('aria-level', '1');
	jQuery('.multicolumn-card__title.h2, .accordion__title.h3, .guarantee__item .h3, .multicolumn-card__title.h3').attr('role', 'heading');
	jQuery('.multicolumn-card__title.h2, .accordion__title.h3, .guarantee__item .h3, .multicolumn-card__title.h3').attr('aria-level', '3');
	
  jQuery('#shopify-section-template--21463335272671__rich_text_nLUUzD h1:eq(1)').attr('role', 'none');

  jQuery('#shopify-section-template--21463336845535__rich_text_Up4Bhe a').attr('aria-label', 'learn more about, Save up to 30% with HSA/FSA!');
  jQuery('#shopify-section-template--21463336845535__rich_text_c4GtiA a').attr('aria-label', 'learn more about Financing');


  
  
	jQuery('a.full-unstyled-link[href="/products/skiers-edge-bronze"]').attr('aria-label', 'skiers edge bronze page');
	jQuery('a.full-unstyled-link[href="/products/skiers-edge-silver"]').attr('aria-label', 'skiers edge silver page');
	jQuery('a.full-unstyled-link[href="/products/skiers-edge-gold"]').attr('aria-label', 'skiers edge gold page');
	jQuery('a.full-unstyled-link[href="/pages/skiers-edge-elite-configurable"]').attr('aria-label', 'skiers edge elite configurable page');
	jQuery('a.full-unstyled-link[href="/pages/skiers-edge-pro-configurable"]').attr('aria-label', 'skiers edge pro configurable page');
	jQuery('a.full-unstyled-link[href="/products/skiers-edge-assistant-coach-bar"]').attr('aria-label', 'skiers edge pro configurable page');
	
	
	
	jQuery('a[href="https://www.instagram.com/theskiersedge/"]').attr('aria-label', 'the skiers edge Instagram page, opens in new tab');
	jQuery('a[href="https://www.instagram.com/thehockeyedge"]').attr('aria-label', 'the hockey edge Instagram page, opens in new tab');
	jQuery('a[href="https://www.youtube.com/@theskiersedgecompany"]').attr('aria-label', 'the skiers edge youtube page, opens in new tab');
	jQuery('a[href="https://www.facebook.com/TheSkiersEdge"]').attr('aria-label', 'the skiers edge facebook page, opens in new tab');
	jQuery('a[href="https://www.youtube.com/@My-Edge"]').attr('aria-label', 'My Edge youtube page, opens in new tab');



	jQuery('.cst-cookie-btn-icon.cst-reopen-trigger').attr('alt', '');
	jQuery('.cst-cookie-btn-icon-wrapper').attr('aria-label', 'Cookie dialog');
	jQuery('.cst-cookie-btn-icon-wrapper').attr('aria-haspopup', 'dialog');
	jQuery('.menu-drawer__close-button.focus-inset').attr('aria-label', 'close');
	jQuery('.rc-discountCode button').attr('aria-label', 'discount copy');
	jQuery('video img').attr('alt', '');
	jQuery('.testimonials-slide-text-btn').remove();
	jQuery('button.deferred-media__poster').attr('aria-label','Play button');

	jQuery('.icon.icon-plus-alt').attr('aria-hidden','true');
	jQuery('.image-with-text__text.typeset2.rte h6').attr('role','none');
	jQuery('.lb-liked-from-three-image-holder img, .lb-price-badge-legitimation-2 img, .lb-pdp-benefits img').attr('alt','');
	jQuery('.ss-payment-list').attr('aria-label','Secure checkout options');

	

	
	jQuery('.cst-banner-title').attr("role","heading");
	jQuery('.cst-banner-title').attr("aria-level","2");
      
	jQuery('.at_left img').attr("alt","Youtube");
	jQuery('input[data-name="Essential"]').attr('id', 'Essential');
	jQuery('input[data-name="Functional"]').attr('id', 'Functional');
	jQuery('input[data-name="Marketing"]').attr('id', 'Marketing');
	jQuery('input[data-name="Analytics"]').attr('id', 'Analytics');

	jQuery('input[data-name="Essential"]').attr('aria-label', 'Essential');
	jQuery('input[data-name="Functional"]').attr('aria-label', 'Functional');
	jQuery('input[data-name="Marketing"]').attr('aria-label', 'Marketing');
	jQuery('input[data-name="Analytics"]').attr('aria-label', 'Analytics');

	jQuery('label[for="quick-cat-45816"]').attr('aria-label', 'Essential');
	jQuery('label[for="quick-cat-45817"]').attr('aria-label', 'Functional');
	jQuery('label[for="quick-cat-45818"]').attr('aria-label', 'Marketing');
	jQuery('label[for="quick-cat-45819"]').attr('aria-label', 'Analytics');

	jQuery('#Slider-template--21463336517855__multicolumn_gJJnYb .multicolumn-card__title.h3').attr('aria-level', '2');
	jQuery('#Slider-template--21463335436511__multicolumn_QqFtUj .multicolumn-card__title.h3').attr('aria-level', '2');
	
  jQuery('#shopify-section-template--21463335436511__contact_form_tGgi7E label').removeClass('visually-hidden');
  jQuery('label[for="line-item-template--21463335436511__contact_form_tGgi7E-custom_field_XR7UkL"]').append(' <span aria-hidden="true">*</span>');
  jQuery('label[for="line-item-template--21463335436511__contact_form_tGgi7E-custom_field_YYJtfE"]').append(' <span aria-hidden="true">*</span>');

  // Name field
    jQuery('input[name="contact[Name]"]').attr('autocomplete', 'name');

  // Email field
jQuery('input[name="contact[email]"], input[type="email"]').attr('autocomplete', 'email');

	jQuery('#line-item-template--21463335436511__contact_form_tGgi7E-custom_field_MPJpeQ').attr('autocomplete', 'tel');



 

  
  
	jQuery(document).ready(function() {
    // Find all empty h2 elements and remove them
    jQuery('h2').each(function() {
      if (!jQuery(this).text().trim()) {
        jQuery(this).remove();
      }
    });
  });

     },
  2000); 


     });




$(document).ready(function () {

  $('a.full-unstyled-link').each(function () {
    var $link = $(this);
    var linkText = $link.text().trim();

    // Only target links with no visible text or only whitespace/nbsp
    if (!linkText || linkText === '\u00A0') {
      var href = $link.attr('href');

      if (!href) return; // skip if no href

      var label = href
        .replace(/^\/(pages|products|collections)\//, '') // strip /pages/ /products/ /collections/
        .replace(/[-_]/g, ' ')                            // hyphens/underscores to spaces
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); }); // Title Case

      $link.attr('aria-label', label + ' page');
    }
  });

});


$('h2').filter(function () {
  return $(this).text().trim() === '';
}).remove();



//  ================================================== AUDIT SHEET ERROR REOMVE CODE  ===============================================
 
// // Main menu accessibility 
// $(document).ready(function () {

//   /* ============================================================
//      WAIT FOR CUSTOM ELEMENTS TO BE DEFINED & UPGRADED
//      MegaMenu is a custom element — we must wait for the browser
//      to upgrade all <mega-menu> instances before we can patch them.
//   ============================================================ */
//   customElements.whenDefined('mega-menu').then(function () {

//     // Extra tick to ensure all instances are fully constructed
//     requestAnimationFrame(function () {

//       /* ==========================================================
//          CORE PATCH — Override handleMouseover on the prototype
//          This kills the focusin auto-open at the source.
//          The theme calls:
//            this.addEventListener('focusin', this.handleMouseover)
//            this.addEventListener('mouseenter', this.handleMouseover)
//          We replace handleMouseover so focusin does nothing,
//          but mouseenter still works for mouse users.
//       ========================================================== */
//       const MegaMenuProto = customElements.get('mega-menu').prototype;

//       // Store the original so mouseenter can still use it
//       const _originalHandleMouseover = MegaMenuProto.handleMouseover;

//       MegaMenuProto.handleMouseover = function (e) {
//         // BLOCK: focusin must never auto-open the menu
//         if (e && e.type === 'focusin') return;

//         // ALLOW: mouseenter proceeds as normal for mouse users
//         _originalHandleMouseover.call(this, e);
//       };


//       /* ==========================================================
//          ARIA + CHEVRON INIT on each mega-menu instance
//       ========================================================== */
//       document.querySelectorAll('mega-menu').forEach(function (megaMenu, index) {
//         const topLink  = megaMenu.querySelector('.header__menu-item--top');
//         const dropdown = megaMenu.querySelector('.list-menu-dropdown');

//         if (!topLink || !dropdown) return;

//         // Unique ID for aria-controls
//         const uid = 'submenu-' + index + '-' + Math.random().toString(36).slice(2, 6);
//         dropdown.id = uid;

//         // ARIA attributes
//         topLink.setAttribute('aria-haspopup', 'true');
//         topLink.setAttribute('aria-expanded', 'false');
//         topLink.setAttribute('aria-controls', uid);

//         // Chevron arrow indicator
//         if (!topLink.querySelector('.a11y-dropdown-arrow')) {
//           const arrow = document.createElement('span');
//           arrow.className = 'a11y-dropdown-arrow';
//           arrow.setAttribute('aria-hidden', 'true');
//           arrow.innerHTML =
//             '<svg focusable="false" width="10" height="6" viewBox="0 0 10 6" ' +
//                  'xmlns="http://www.w3.org/2000/svg">' +
//               '<path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" ' +
//                     'fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
//             '</svg>';
//           topLink.appendChild(arrow);
//         }
//       });


//       /* ==========================================================
//          INJECT STYLES
//       ========================================================== */
//       if (!document.getElementById('a11y-megamenu-styles')) {
//         const style = document.createElement('style');
//         style.id = 'a11y-megamenu-styles';
//         style.textContent = `
//           .a11y-dropdown-arrow {
//             display: inline-flex;
//             align-items: center;
//             margin-left: 4px;
//             transition: transform 0.2s ease;
//             pointer-events: none;
//           }
//           mega-menu.is-active > a .a11y-dropdown-arrow {
//             transform: rotate(180deg);
//           }
//         `;
//         document.head.appendChild(style);
//       }


//       /* ==========================================================
//          HELPERS — sync aria-expanded with theme's is-active class
//          The theme uses classList.add('is-active') to open and
//          classList.remove('is-active') to close. We watch for
//          those class changes to keep aria-expanded in sync.
//       ========================================================== */
//       function syncAriaExpanded(megaMenu) {
//         const topLink = megaMenu.querySelector('.header__menu-item--top');
//         if (!topLink) return;
//         const isOpen = megaMenu.classList.contains('is-active');
//         topLink.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
//       }

//       // MutationObserver watches is-active toggling on each mega-menu
//       const observer = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {
//           if (mutation.attributeName === 'class') {
//             syncAriaExpanded(mutation.target);
//           }
//         });
//       });

//       document.querySelectorAll('mega-menu').forEach(function (megaMenu) {
//         observer.observe(megaMenu, { attributes: true });
//       });


//       /* ==========================================================
//          KEYBOARD TOGGLE — Enter / Space opens the menu deliberately
//          WCAG 2.2 AA → 2.1.1 Keyboard, 4.1.2 Name Role Value
//       ========================================================== */
//       document.querySelectorAll('mega-menu').forEach(function (megaMenu) {
//         const topLink = megaMenu.querySelector('.header__menu-item--top');
//         if (!topLink) return;

//         topLink.addEventListener('keydown', function (e) {
//           if (e.key !== 'Enter' && e.key !== ' ') return;
//           e.preventDefault();
//           e.stopImmediatePropagation();

//           const isOpen = megaMenu.classList.contains('is-active');

//           if (isOpen) {
//             // Close: call the theme's own close() method
//             megaMenu.close();
//           } else {
//             // Open: call the theme's own handleMouseover,
//             // passing a synthetic mouseenter event so our
//             // patched guard doesn't block it
//             const syntheticEvent = new MouseEvent('mouseenter', { bubbles: false });
//             megaMenu.handleMouseover(syntheticEvent);

//             // Move focus to first link inside the dropdown
//             const firstLink = megaMenu.querySelector('.list-menu-dropdown a, .list-menu-dropdown button');
//             if (firstLink) {
//               requestAnimationFrame(function () {
//                 firstLink.focus();
//               });
//             }
//           }
//         });
//       });


//       /* ==========================================================
//          ESC KEY — close open menu & return focus to trigger
//          WCAG 2.2 AA → 2.1.2 No Keyboard Trap
//       ========================================================== */
//       document.addEventListener('keydown', function (e) {
//         if (e.key !== 'Escape') return;

//         const openMenu = document.querySelector('mega-menu.is-active');
//         if (!openMenu) return;

//         const topLink = openMenu.querySelector('.header__menu-item--top');

//         openMenu.close();           // theme's own close method
//         if (topLink) topLink.focus(); // return focus to trigger
//       });


//       /* ==========================================================
//          FOCUSOUT — collapse if focus leaves the nav entirely
//          WCAG 2.2 AA → 2.1.1 Keyboard
//       ========================================================== */
//       const nav = document.querySelector('nav.header__inline-menu');
//       if (nav) {
//         nav.addEventListener('focusout', function () {
//           setTimeout(function () {
//             if (!nav.contains(document.activeElement)) {
//               const openMenu = document.querySelector('mega-menu.is-active');
//               if (openMenu) openMenu.close();
//             }
//           }, 100);
//         });
//       }

//     }); // end requestAnimationFrame
//   }); // end customElements.whenDefined

// }); // end document.ready


customElements.whenDefined('mega-menu').then(function () {
  requestAnimationFrame(function () {

    document.querySelectorAll('mega-menu').forEach(function (megaMenu) {

      /* ============================================================
         THE DEFINITIVE FIX
         .bind(this) in the constructor means the focusin listener
         is a unique, unreachable function reference stored nowhere.
         We cannot remove it. We cannot override it via prototype.

         SOLUTION: Intercept at the event level using a CAPTURE-phase
         listener on the <mega-menu> element itself with stopImmediatePropagation().
         Capture fires BEFORE bubble. The theme's focusin listener is
         bubble-phase. We stop propagation in capture so it never fires.
      ============================================================ */
      megaMenu.addEventListener('focusin', function (e) {

        // BLOCK the event completely — theme's bound bubble-phase
        // focusin handler will never receive it.
        e.stopImmediatePropagation();

        // Do NOT open the menu. Do nothing.

      }, true); // <-- true = capture phase, critical

    });

  });
});


//  ================================================== play/pause bug id 25 ===================================================================
jQuery(document).ready(function () {

  const $ticker = jQuery('scrolling-promotion');
  if (!$ticker.length) return;

  let paused = false;

  // Inject pause button
  const $btn = jQuery(
    '<button id="a11y-ticker-btn" type="button" aria-label="Pause scrolling promotions" aria-pressed="false">' +
    'Pause</button>'
  ).insertBefore($ticker);

  // Styles
  jQuery('head').append('<style>' +
    '#a11y-ticker-btn{position:absolute;' +
    'z-index:10;background:rgba(0,0,0,0.5);color:#fff;border:1px solid rgba(255,255,255,0.4);' +
    'border-radius:4px;padding:4px 10px;font-size:14px;cursor:pointer; left: 12px; }' +
    '#a11y-ticker-btn:focus-visible{outline:2px solid #fff;outline-offset:2px;}' +
    'scrolling-promotion{position:relative;}' +
    'scrolling-promotion.is-paused .promotion--animated{animation-play-state:paused!important;}' +
  '</style>');

  // Toggle
  $btn.on('click', function () {
    paused = !paused;
    $ticker.toggleClass('is-paused', paused);
    $btn
      .text(paused ? 'Play' : 'Pause')
      .attr('aria-label', (paused ? 'Play' : 'Pause') + ' scrolling promotions')
      .attr('aria-pressed', paused);
  });

  // Auto-pause if reduced motion preferred
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $btn.trigger('click');
  }

});


//  ================================================== play/pause bug id 27 ===================================================================


jQuery(document).ready(function () {

  const banners = [
    '#Banner-template--21463335207135__video_hero_EUqCYh',
    '#Banner-template--21463336059103__video_hero_f9RrPN',
    '#Banner-template--21463335993567__video_hero_HTPnBB',
    '#Banner-template--22142733254879__video_hero_f9RrPN'
  ];

  jQuery('head').append('<style>' +
    '.a11y-video-btn{position:absolute;bottom:12px;bottom:12px;' +
    'z-index:10;background:rgba(0,0,0,0.5);color:#fff;' +
    'border:1px solid rgba(255,255,255,0.4);' +
    'border-radius:4px;padding:4px 10px;font-size:14px;cursor:pointer;}' +
    '.banner{position:relative;}' +
  '</style>');

  jQuery.each(banners, function (i, bannerId) {
    const $banner = jQuery(bannerId);
    const $video  = $banner.find('video');
    if (!$banner.length || !$video.length) return;

    let paused = false;

    const $btn = jQuery(
      '<button type="button" class="a11y-video-btn focus-inset" ' +
      'aria-label="Pause background video" aria-pressed="false">' +
      'Pause</button>'
    ).appendTo($banner);

    $btn.on('click', function () {
      paused = !paused;
      paused ? $video[0].pause() : $video[0].play();
      $btn
        .text(paused ? 'Play' : 'Pause')
        .attr('aria-label', (paused ? 'Play' : 'Pause') + ' background video')
        .attr('aria-pressed', paused);
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      $btn.trigger('click');
    }
  });

});
//  ================================================== footer landmark missing for disclaimer bug id 30 ===================================================================


$(document).ready(function () {

  /* =========================
     1. TARGET SECTIONS
  ==========================*/
  var $customerSection = $('#shopify-section-sections--21463337140447__custom_liquid_XzQ7yh');
  var $legalSection = $('#shopify-section-sections--21463337140447__ss_text_block_pro_EJeqQc');

  var $footer = $('footer');

  /* =========================
     2. MOVE INTO FOOTER
  ==========================*/
  if ($footer.length) {
    $footer.append($customerSection);
    $footer.append($legalSection);
  }

  /* =========================
     3. ADD ACCESSIBLE ROLES
  ==========================*/

  // Customer section
  $customerSection.attr({
    'role': 'region',
    'aria-labelledby': 'customer-id-heading'
  });

  // Add hidden heading if not present
  if (!$('#customer-id-heading').length) {
    $customerSection.prepend(
      '<h2 id="customer-id-heading" class="visually-hidden">Customer Information</h2>'
    );
  }

  // Legal section
  $legalSection.attr({
    'role': 'region',
    'aria-labelledby': 'legal-heading'
  });

  if (!$('#legal-heading').length) {
    $legalSection.prepend(
      '<h2 id="legal-heading" class="visually-hidden">Legal and Warranty Information</h2>'
    );
  }


  /* =========================
     4. FIX SMALL TEXT (OPTIONAL)
  ==========================*/
  $legalSection.find('p, a, li').css('font-size', '14px');


  /* =========================
     5. FIX LINKS (OPEN SAFELY)
  ==========================*/
  $legalSection.find('a[target="_blank"]').attr({
    'rel': 'noopener noreferrer'
  });


  /* =========================
     6. IMPROVE CUSTOMER ID LABEL
  ==========================*/
  $('#nf_customer_code').attr({
    'aria-label': 'Customer ID 083 969 096'
  });

});

//  ================================================== FAQS accordians expanded/collapse ===================================================================

jQuery(document).ready(function () {

  jQuery('.accordion details').each(function (i) {
    const $details = jQuery(this);
    const $summary = $details.find('> summary');
    const $content = $details.find('.accordion__content');
    const $title   = $summary.find('.accordion__title');

    /* -- Unique IDs ---------------------------------------- */
    const contentId = 'accordion-content-' + i;
    const titleId   = 'accordion-title-'   + i;

    $content.attr('id', contentId);
    $title.attr('id', titleId);

    /* -- FIX 1: Title semantic heading --------------------- */
    $title
      .attr('role',       'heading')
      .attr('aria-level', '3');

    /* -- FIX 2: Remove role="button" from summary ----------
       <summary> is natively interactive — adding role="button"
       causes duplicate role announcement in NVDA/VoiceOver.
       Browser already exposes it as a disclosure widget.
    ------------------------------------------------------- */
    $summary
      .removeAttr('role')                // remove conflicting role
      .attr('aria-expanded', $details.prop('open') ? 'true' : 'false')
      .attr('aria-controls', contentId);

    /* -- FIX 3: Content region ----------------------------- */
    $content.attr({
      'role'            : 'region',
      'aria-labelledby' : titleId
    });

    /* -- FIX 4: Sync aria-expanded on native toggle --------
       Use the native <details> toggle event — more reliable
       than click + setTimeout
    ------------------------------------------------------- */
    this.addEventListener('toggle', function () {
      $summary.attr('aria-expanded', $details.prop('open') ? 'true' : 'false');
    });
  });

});

//  ================================================== Radio button was not working bug id 42 ===================================================================

jQuery(document).ready(function () {

  /* ============================================================
     VARIANT RADIO BUTTONS — Keyboard Arrow Key Fix
     WCAG 2.2 AA → 2.1.1 Keyboard

     ROOT CAUSE: form="" (empty) on each <input type="radio">
     breaks the browser's native radio group — arrow keys stop
     working because browser can't identify which inputs belong
     to the same group without a valid form association.

     FIX: Remove empty form attribute + ensure correct
     aria grouping via fieldset/legend.
  ============================================================ */

  jQuery('variant-radios fieldset.variant-input-wrapper').each(function () {
    const $fieldset = jQuery(this);
    const $inputs   = $fieldset.find('input[type="radio"]');
    const $legend   = $fieldset.find('legend.form__label');

    /* ----------------------------------------------------------
       FIX 1 — Remove empty form="" attribute
       Empty form="" disassociates inputs from their form,
       breaking native radio group arrow key behaviour
    ---------------------------------------------------------- */
    $inputs.each(function () {
      if (jQuery(this).attr('form') === '') {
        jQuery(this).removeAttr('form');
      }
    });

    /* ----------------------------------------------------------
       FIX 2 — Ensure fieldset has correct role
       fieldset + legend is the correct ARIA pattern for
       radio groups — no additional role needed but confirm
       legend is not empty
    ---------------------------------------------------------- */
    if (!$legend.text().trim()) {
      $legend.text($fieldset.data('option-slug') || 'Option');
    }

    /* ----------------------------------------------------------
       FIX 3 — Add aria-required if only one option exists
       and add aria-describedby for error messaging support
    ---------------------------------------------------------- */
    $fieldset.attr('aria-required', 'true');

    /* ----------------------------------------------------------
       FIX 4 — Manual arrow key handler as safety net
       In case theme JS intercepts keyboard events and prevents
       default browser radio group arrow key behaviour
    ---------------------------------------------------------- */
    $inputs.on('keydown.variantRadio', function (e) {
      const $all     = $fieldset.find('input[type="radio"]:not([disabled])');
      const total    = $all.length;
      const current  = $all.index(this);

      let next = -1;

      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        next = (current + 1) % total;
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        next = (current - 1 + total) % total;
      } else {
        return; // let other keys pass through
      }

      e.preventDefault();

      const $next = $all.eq(next);

      // Focus and select the next radio
      $next.prop('checked', true).trigger('focus').trigger('change');

      // Update tabindex — only focused radio should be in tab order
      $all.attr('tabindex', '-1');
      $next.attr('tabindex', '0');
    });

    /* ----------------------------------------------------------
       FIX 5 — Roving tabindex pattern
       Only the checked (or first) radio is in tab order.
       Arrow keys move focus within the group.
       WCAG 2.2 AA → 2.1.1 Keyboard
    ---------------------------------------------------------- */
    function updateTabindex() {
      const $checked = $inputs.filter(':checked');
      $inputs.attr('tabindex', '-1');
      if ($checked.length) {
        $checked.attr('tabindex', '0');
      } else {
        $inputs.first().attr('tabindex', '0');
      }
    }

    updateTabindex();

    // Re-apply on change (theme may re-render inputs)
    $inputs.on('change.variantRadio', updateTabindex);
  });

});

//  ================================================== Dialog box bug id 43 ===================================================================

jQuery(document).ready(function () {

  const FEATHERLIGHT  = '.featherlight';
  const CONTENT       = '.featherlight-content';
  const CLOSE_BTN     = '.featherlight-close';
  const POPUP         = '.actionOfferPopup_0';
  const NO_THANKS     = '.continue-button-action';

  let popupTrigger = null;

  /* ----------------------------------------------------------
     FOCUSABLE — scoped to featherlight-content (includes
     close button which sits outside .actionOfferPopup_0)
  ---------------------------------------------------------- */
  function getFocusable() {
    return jQuery(CONTENT).find(
      'a[href], button:not([disabled]), [tabindex="0"]'
    ).filter(':visible');
  }

  /* ----------------------------------------------------------
     FIX — Apply all ARIA + tabindex fixes
  ---------------------------------------------------------- */
  function fixPopup() {
    const $fl = jQuery(FEATHERLIGHT);
    if (!$fl.length || !$fl.is(':visible')) return;

    /* ---- Move role="dialog" to featherlight-content ---- */
    /* Inner .actionOfferPopup_0 has role="dialog" but the  */
    /* close button is a sibling — not inside the dialog.   */
    /* Move dialog role up to .featherlight-content so both */
    /* close button + content are inside the dialog region. */
    jQuery(POPUP).removeAttr('role aria-modal aria-labelledby');

    jQuery(CONTENT)
      .attr('role',          'dialog')
      .attr('aria-modal',    'true')
      .attr('aria-labelledby', 'a11y-popup-title');

    /* ---- Title ID ---------------------------------------- */
    jQuery(POPUP).find('.actionpopup_text h3')
      .attr('id', 'a11y-popup-title');

    /* ---- Close button ------------------------------------ */
    jQuery(CLOSE_BTN)
      .attr('aria-label', 'Close dialog')
      .attr('tabindex',   '0');

    /* ---- Unlock all tabindex="-1" (skip hidden inputs) -- */
    jQuery(CONTENT).find('[tabindex="-1"]').each(function () {
      if (!jQuery(this).is('input[type="hidden"]')) {
        jQuery(this).attr('tabindex', '0');
      }
    });

    /* ---- Add button labels ------------------------------- */
    jQuery(CONTENT).find('.launchtip_add_to_cart').each(function () {
      const $item  = jQuery(this).closest('.productbox');
      const title  = $item.find('.title').attr('title') ||
                     $item.find('.title').text().trim();
      const price  = $item.find('.price').text().trim();
      if (title) {
        jQuery(this).attr('aria-label', 'Add ' + title + ' ' + price + ' to cart');
      }
    });

    /* ---- No thanks link ---------------------------------- */
    jQuery(NO_THANKS)
      .attr('aria-label', 'No thanks, continue without replacement tools');

    /* ---- Prevent background scroll ---------------------- */
    jQuery('body').css('overflow', 'hidden');

    /* ---- Move focus to close button ---------------------- */
    setTimeout(function () {
      jQuery(CLOSE_BTN).focus();
    }, 100);
  }

  /* ----------------------------------------------------------
     FOCUS TRAP — scoped to .featherlight-content
     WCAG 2.2 AA → 2.1.2 No Keyboard Trap
  ---------------------------------------------------------- */
  jQuery(document).on('keydown.flTrap', function (e) {
    if (!jQuery(FEATHERLIGHT).is(':visible')) return;
    if (e.key !== 'Tab') return;

    const $focusable = getFocusable();
    if (!$focusable.length) return;

    const $first  = $focusable.first();
    const $last   = $focusable.last();
    const $active = jQuery(document.activeElement);
    const content = document.querySelector(CONTENT);

    if (!content || !content.contains(document.activeElement)) {
      e.preventDefault();
      $first.focus();
      return;
    }

    if (e.shiftKey) {
      if ($active.is($first)) { e.preventDefault(); $last.focus(); }
    } else {
      if ($active.is($last))  { e.preventDefault(); $first.focus(); }
    }
  });

  /* ----------------------------------------------------------
     ESC — close dialog
     WCAG 2.2 AA → 2.1.2 No Keyboard Trap
  ---------------------------------------------------------- */
  jQuery(document).on('keydown.flEsc', function (e) {
    if (e.key !== 'Escape') return;
    if (!jQuery(FEATHERLIGHT).is(':visible')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    closePopup();
  });

  /* ----------------------------------------------------------
     CLOSE POPUP — restore focus + prevent cart redirect
  ---------------------------------------------------------- */
  function closePopup() {
    jQuery('body').css('overflow', '');

    if (jQuery.featherlight && jQuery.featherlight.current()) {
      jQuery.featherlight.current().close();
    } else {
      jQuery(FEATHERLIGHT).fadeOut(200, function () {
        jQuery(this).remove();
      });
    }

    if (popupTrigger && document.body.contains(popupTrigger)) {
      setTimeout(function () {
        jQuery(popupTrigger).focus();
        popupTrigger = null;
      }, 100);
    }
  }

  /* ----------------------------------------------------------
     No thanks — prevent href="#" page jump + cart redirect
  ---------------------------------------------------------- */
  jQuery(document).on('click.noThanks keydown.noThanks', NO_THANKS, function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    closePopup();
  });

  /* ----------------------------------------------------------
     MutationObserver — detect featherlight injection
  ---------------------------------------------------------- */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        const $node = jQuery(node);
        if (
          $node.hasClass('featherlight') ||
          $node.find(POPUP).length
        ) {
          popupTrigger = document.activeElement;
          setTimeout(fixPopup, 150);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Run on load if already present
  if (jQuery(FEATHERLIGHT).length) {
    popupTrigger = document.activeElement;
    fixPopup();
  }

});

jQuery(document).ready(function () {

  /* ============================================================
     UPSELL POPUP — "Added" announcement for screen readers
     WCAG 2.2 AA → 4.1.3 Status Messages
     When button changes to "Added", screen readers must be
     notified without moving focus.
  ============================================================ */

  // Inject live region once
  if (!document.getElementById('a11y-cart-announce')) {
    jQuery('body').append(
      '<div id="a11y-cart-announce" role="status" aria-live="polite" ' +
      'aria-atomic="true" style="position:absolute;width:1px;height:1px;' +
      'padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);' +
      'white-space:nowrap;border:0;"></div>'
    );
  }

  function announce(text) {
    const r = document.getElementById('a11y-cart-announce');
    if (!r) return;
    r.textContent = '';
    setTimeout(function () { r.textContent = text; }, 100);
  }

  /* ----------------------------------------------------------
     Watch for button text changing to "Added"
     Theme changes button text from "Add" → "Added" on success
  ---------------------------------------------------------- */
  jQuery(document).on('click.addedAnnounce', '.launchtip_add_to_cart', function () {
    const $btn      = jQuery(this);
    const $item     = $btn.closest('.productbox');
    const title     = $item.find('.title').attr('title') ||
                      $item.find('.title').text().trim();
    const price     = $item.find('.price').text().trim();

    // Observe button text change → "Added"
    const observer = new MutationObserver(function () {
      const btnText = $btn.text().trim();
      if (btnText === 'Added') {
        announce(title + ' ' + price + ' has been added to your cart.');

        // Update aria-label to reflect new state
        $btn.attr('aria-label', title + ' ' + price + ' added to cart');
        observer.disconnect();
      }
    });

    observer.observe($btn[0], {
      childList: true,
      subtree  : true,
      characterData: true
    });
  });

});

//  ================================================== Multiple view munual links bug id 49 ===================================================================

jQuery(document).ready(function () {

  setTimeout(function () {

    jQuery('#Slider-template--21463336517855__multicolumn_gJJnYb .multicolumn-card').each(function () {
      const $card  = jQuery(this);
      const title  = $card.find('[role="heading"]').text().trim();

      $card.find('a').each(function () {
        const $link    = jQuery(this);
        const linkText = $link.text().trim();
        const target   = $link.attr('target') === '_blank' ? ', opens in new tab' : '';

        if (title && linkText) {
          $link.attr('aria-label', linkText + ' for ' + title + target);
        }
      });
    });

  }, 2000); // 2 second delay

});

//  ================================================== Add to card button on hover bug id 54 ===================================================================

jQuery(document).ready(function () {

  /* ============================================================
     ADD TO CART BUTTON — Keyboard + SR Accessible
     WCAG 2.2 AA → 2.1.1 Keyboard / 1.3.1 Info & Relationships

     PROBLEM: Button only appears on CSS :hover via opacity/
     transform. Keyboard focus on the card does not trigger
     :hover so button stays hidden and unreachable.

     FIX 1: Show button on card focus-within
     FIX 2: Unlock card tabindex="-1"
     FIX 3: Add product name to "Add to cart" aria-label
  ============================================================ */

  /* ----------------------------------------------------------
     FIX 1 — CSS: show button on focus-within
  ---------------------------------------------------------- */
  if (!document.getElementById('a11y-card-styles')) {
    jQuery('head').append(
      '<style id="a11y-card-styles">' +
        /* Show add-to-cart button when any element inside
           the card receives keyboard focus */
        '.card-wrapper:focus-within .card-information__button,' +
        '.card-wrapper:focus-within .card-information__button .button {' +
          'opacity: 1 !important;' +
          'transform: translateY(0) !important;' +
          'pointer-events: auto !important;' +
        '}' +
      '</style>'
    );
  }

  /* ----------------------------------------------------------
     FIX 2 — Unlock use-animate tabindex="-1"
     Card wrapper has tabindex="-1" blocking keyboard access
  ---------------------------------------------------------- */
  jQuery('use-animate.card.card--product[tabindex="-1"]').each(function () {
    jQuery(this).removeAttr('tabindex');
  });

  /* ----------------------------------------------------------
     FIX 3 — Descriptive aria-label on Add to Cart button
     WCAG 2.2 AA → 4.1.2 Name, Role, Value
     "Add to cart" alone doesn't identify which product
  ---------------------------------------------------------- */
  jQuery('.card-wrapper').each(function () {
    const $card    = jQuery(this);
    const $btn     = $card.find('add-to-cart');
    const $link    = $card.find('a.full-unstyled-link');

    // Get product name from link text or aria-label
    const productName = $link.attr('aria-label') ||
                        $link.text().trim() ||
                        $card.find('.card__heading, .card-information__text, h3, h2')
                             .first().text().trim();

    if (productName && $btn.length) {
      $btn.find('.button').attr(
        'aria-label',
        'Add ' + productName + ' to cart'
      );
    }
  });

  /* ----------------------------------------------------------
     FIX 4 — Ensure product image links have accessible name
     WCAG 2.2 AA → 4.1.2 Name, Role, Value
  ---------------------------------------------------------- */
  jQuery('.card-wrapper a.full-unstyled-link').each(function () {
    const $a = jQuery(this);
    if (!$a.attr('aria-label') && !$a.text().trim()) {
      const imgAlt = $a.closest('.card-wrapper')
                       .find('img').first().attr('alt');
      if (imgAlt) $a.attr('aria-label', imgAlt);
    }
  });

});

jQuery(document).ready(function () {

  /* ============================================================
     ADD-TO-CART CUSTOM ELEMENT — Keyboard + SR Fix
     WCAG 2.2 AA → 4.1.2 Name, Role, Value / 2.1.1 Keyboard

     PROBLEM: <add-to-cart> is a custom element with no native
     button role — keyboard cannot activate it, screen readers
     don't announce it as interactive.
  ============================================================ */

  function fixAddToCartButtons() {
    jQuery('add-to-cart').each(function () {
      const $el          = jQuery(this);
      const variantId    = $el.attr('data-variant-id');
      const $card        = $el.closest('.card-wrapper');

      // Get product name for descriptive label
      const productName  =
        $card.find('a.full-unstyled-link').attr('aria-label') ||
        $card.find('.card__heading, h3, h2').first().text().trim() ||
        $card.find('img').first().attr('alt') || '';

      const label = productName
        ? 'Add ' + productName + ' to cart'
        : 'Add to cart';

      // Fix: expose as button to AT
      $el
        .attr('role',         'button')
        .attr('tabindex',     '0')
        .attr('aria-label',   label);

      // Keyboard activation — Enter + Space
      $el.off('keydown.atcFix').on('keydown.atcFix', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          jQuery(this).trigger('click');
        }
      });
    });
  }

  fixAddToCartButtons();

  // Re-run when new cards are injected (infinite scroll, filters)
  new MutationObserver(function () {
    requestAnimationFrame(fixAddToCartButtons);
  }).observe(document.body, { childList: true, subtree: true });

});

//  ================================================== play/pause button bug id 60 ===================================================================

jQuery(document).ready(function () {

  jQuery('use-animate').each(function () {
    const $img = jQuery(this).find('img');
    if (!$img.length) return;

    const src = $img.attr('src') || '';
    if (src.toLowerCase().indexOf('.gif') === -1) return;

    let paused  = false;
    const stillSrc = src;

    /* -- Canvas for pause snapshot ------------------------- */
    const canvas = document.createElement('canvas');
    const ctx    = canvas.getContext('2d');
    canvas.className     = $img[0].className;
    canvas.style.cssText = 'display:none;width:100%;height:auto;';
    $img[0].parentNode.insertBefore(canvas, $img[0].nextSibling);

    function captureFrame() {
      try {
        canvas.width  = $img[0].naturalWidth  || $img[0].offsetWidth;
        canvas.height = $img[0].naturalHeight || $img[0].offsetHeight;
        ctx.drawImage($img[0], 0, 0, canvas.width, canvas.height);
      } catch (e) {}
    }

    function pauseGif() {
      captureFrame();
      $img.hide();
      jQuery(canvas).show();
      paused = true;
      $btn
        .text('Play')
        .attr('aria-label', 'Play animation')
        .attr('aria-pressed', 'true');
    }

    function playGif() {
      jQuery(canvas).hide();
      $img.attr('src', '').attr('src', stillSrc);
      $img.show();
      paused = false;
      $btn
        .text('Pause')
        .attr('aria-label', 'Pause animation')
        .attr('aria-pressed', 'false');
    }

    /* -- Inject button only -------------------------------- */
    const $btn = jQuery(
      '<button type="button" class="a11y-gif-toggle focus-inset" ' +
      'aria-label="Pause animation" aria-pressed="false">Pause</button>'
    );

    jQuery(this).after($btn);

    $btn.on('click', function () {
      paused ? playGif() : pauseGif();
    });

    /* -- Auto-pause on reduced motion ---------------------- */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTimeout(pauseGif, 500);
    }
  });

  /* -- Styles -------------------------------------------- */
  if (!document.getElementById('a11y-gif-styles')) {
    jQuery('head').append(
      '<style id="a11y-gif-styles">' +
        '.a11y-gif-toggle{display:block;margin:8px auto 0;' +
        'background:rgba(0,0,0,0.6);color:#fff;' +
        'border:1px solid rgba(255,255,255,0.4);' +
        'border-radius:4px;padding:4px 12px;font-size:13px;cursor:pointer;}' +
        '.a11y-gif-toggle:focus-visible{outline:2px solid #fff;outline-offset:2px;}' +
      '</style>'
    );
  }

});

//  ================================================== Contact us label bug id 63 ===================================================================


jQuery(document).ready(function () {

  /* ============================================================
     CONTACT FORM — Move label before input
     WCAG 2.2 AA → 1.3.1 Info & Relationships
     Labels must precede their inputs in DOM order for
     screen readers and speech recognition software.
  ============================================================ */

  jQuery('#shopify-section-template--21463335436511__contact_form_tGgi7E .field').each(function () {
    const $field = jQuery(this);
    const $label = $field.find('label');
    const $input = $field.find('input, textarea, select');

    if ($label.length && $input.length) {
      // Move label before input
      $input.before($label);
    }
  });

});

//  ================================================== payment icons accessible bug id 75 ===================================================================

jQuery(document).ready(function () {

  // Payment icon labels in DOM order
  var paymentLabels = [
    'Google Pay',
    'Apple Pay',
    'PayPal',
    'Mastercard',
    'Visa',
    'American Express'
  ];

  // Fix 1: Remove invalid <p> inside <ul> — move text to aria-label on <ul>
  var $list = jQuery('.ss-payment-list');
  $list.find('p.ss-payment-text').remove();
  $list.attr('aria-label', 'Secure checkout options');

  // Fix 2: Add role="img" + aria-label to each icon wrapper div
  // Fix 3: Add aria-hidden="true" + focusable="false" to each SVG
  $list.find('.ss-payment-item').each(function (index) {
    var label = paymentLabels[index] || 'Payment option';

    jQuery(this)
      .find('.ss-payment-icon')
      .attr({
        'role': 'img',
        'aria-label': label
      });

    jQuery(this)
      .find('svg')
      .attr({
        'aria-hidden': 'true',
        'focusable': 'false'
      });
  });

});

//  ================================================== dialog box opening cart page on closing bug id 76 ===================================================================


jQuery(document).ready(function () {

  // ─── Helper: clean close without redirect ────────────────────────────────
  function closeDialog() {
    jQuery('.featherlight').fadeOut(200, function () {
      jQuery('.featherlight').remove();

      // Restore body scroll that Featherlight locks on open
      jQuery('body').css({
        'overflow': '',
        'padding-right': ''
      });
      jQuery('html').css('overflow', '');
    });

    // Return focus to trigger element
    jQuery('[data-featherlight], .featherlight-trigger').last().trigger('focus');
  }

  // ─── 1. Block "No, thanks" default href navigation ───────────────────────
  jQuery(document).on('click', '.continue-button-action', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    closeDialog();
  });

  // ─── 2. Block ✕ close button from triggering redirect ────────────────────
  jQuery(document).on('click', '.featherlight-close-icon.featherlight-close', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    closeDialog();
  });

  // ─── 3. Block ESC key redirect ───────────────────────────────────────────
  jQuery(document).on('keydown', function (e) {
    if (e.key === 'Escape' && jQuery('.featherlight').is(':visible')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      closeDialog();
    }
  });

  // ─── 4. Block clicking outside dialog (featherlight overlay) ─────────────
  jQuery(document).on('click', '.featherlight', function (e) {
    if (jQuery(e.target).hasClass('featherlight')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      closeDialog();
    }
  });

  // ─── 5. Intercept form submit — AJAX add to cart, then redirect ───────────
  jQuery(document).on('submit', '.LaunchTipAddToCartForm', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var $form = jQuery(this);
    var formData = $form.serialize();

    jQuery.post('/cart/add.js', formData, function () {

      // Restore scroll before redirecting
      jQuery('body').css({
        'overflow': '',
        'padding-right': ''
      });
      jQuery('html').css('overflow', '');

      // Intentional redirect only after Add button
      window.location.href = '/cart';

    }).fail(function () {
      alert('There was an issue adding the item to your cart. Please try again.');
    });
  });

});

//  ==================================================  accordion accessible bug id 81 ===================================================================

jQuery(document).ready(function () {

  // ─── Fix each accordion trigger ──────────────────────────────────────────
  jQuery('.tab-collage__item').each(function (index) {

    var $item    = jQuery(this);
    var $trigger = $item.find('.tab-collage__heading');
    var $desc    = $item.find('.tab-collage__desc');

    // Generate unique IDs for aria relationships
    var triggerId = 'accordion-trigger-' + index;
    var panelId   = 'accordion-panel-' + index;

    // ─── 1. Convert <p> trigger to accessible button-like element ──────────
    $trigger.attr({
      'id'              : triggerId,
      'role'            : 'button',
      'tabindex'        : '0',
      'aria-expanded'   : 'false',
      'aria-controls'   : panelId,
      'cursor'          : 'pointer'
    }).css('cursor', 'pointer');

    // ─── 2. Set up panel with proper ARIA ──────────────────────────────────
    $desc.attr({
      'id'              : panelId,
      'role'            : 'region',
      'aria-labelledby' : triggerId,
      'hidden'          : true
    }).hide();

    // ─── 3. Toggle function ────────────────────────────────────────────────
    function toggleAccordion() {
      var isExpanded = $trigger.attr('aria-expanded') === 'true';

      // Collapse all other items first
      jQuery('.tab-collage__item').each(function () {
        var $otherTrigger = jQuery(this).find('.tab-collage__heading');
        var $otherDesc    = jQuery(this).find('.tab-collage__desc');

        if ($otherTrigger[0] !== $trigger[0]) {
          $otherTrigger.attr('aria-expanded', 'false');
          $otherDesc.attr('hidden', true).slideUp(200);
        }
      });

      // Toggle current item
      if (isExpanded) {
        $trigger.attr('aria-expanded', 'false');
        $desc.attr('hidden', true).slideUp(200);
      } else {
        $trigger.attr('aria-expanded', 'true');
        $desc.removeAttr('hidden').slideDown(200);
      }
    }

    // ─── 4. Click handler ─────────────────────────────────────────────────
    $trigger.on('click', function () {
      toggleAccordion();
    });

    // ─── 5. Keyboard handler — Enter and Space activate ───────────────────
    $trigger.on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleAccordion();
      }

      // Arrow key navigation between accordion headers (ARIA pattern)
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var $next = $item.next('.tab-collage__item').find('.tab-collage__heading');
        if ($next.length) $next.trigger('focus');
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        var $prev = $item.prev('.tab-collage__item').find('.tab-collage__heading');
        if ($prev.length) $prev.trigger('focus');
      }

      // Home key — jump to first accordion
      if (e.key === 'Home') {
        e.preventDefault();
        jQuery('.tab-collage__item').first().find('.tab-collage__heading').trigger('focus');
      }

      // End key — jump to last accordion
      if (e.key === 'End') {
        e.preventDefault();
        jQuery('.tab-collage__item').last().find('.tab-collage__heading').trigger('focus');
      }
    });

  });

});

//  ==================================================  cart mini close button ===================================================================


$(document).on('keydown', 'drawer-close-button', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
    }
});


if (!$('#cart-status').length) {
    $('body').append(
        '<div id="cart-status" class="visually-hidden" aria-live="polite" aria-atomic="true"></div>'
    );
}

function announceCartClosed() {
    setTimeout(function () {
        $('#cart-status').text('Shopping cart closed');
    }, 1000);
}

// ✅ Single click handler — covers mouse, touch, AND keyboard-triggered clicks
$(document).on('click', 'drawer-close-button', function () {
    announceCartClosed();
});

// ✅ Keyboard handler ONLY simulates the click — does NOT announce directly
// This is required because <drawer-close-button> is a custom element,
// not a native <button>, so Enter/Space won't fire 'click' on their own.
$(document).on('keydown', 'drawer-close-button', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');   // triggers the click handler above — announcement happens once
    }
});


//  ==================================================  remove <p> as heading ===================================================================


    $(document).ready(function () {

      $('.h4.accordion__title').filter(function () {
                return $.trim($(this).text()) === '';
            }).remove();

   $('p.h3[role="heading"][aria-level="3"]').filter(function () {
                return $.trim($(this).text()) === '';
            }).remove();
            
    if (window.location.pathname === '/pages/financing') {
        setTimeout(function () {

          $('p.h3[role="heading"][aria-level="3"]').filter(function () {
                return $.trim($(this).text()) === '';
            }).remove();
            

            $('p.h3[role="heading"][aria-level="3"]').filter(function () {
                return $.trim($(this).text()) === '';
            }).remove();

            $('.multicolumn-card__title.h2').filter(function () {
                return $.trim($(this).text()) === '';
            }).remove();

        }, 3000);
    }
});

//  ==================================================  active phone number ===================================================================


$('#Slide-template--21463335436511__multicolumn_QqFtUj-1, #Slide-template--21463336485087__multicolumn_rDHkzf-1').html(function (_, html) {
    return html
        .replace('800-225-9669', '<a href="tel:8002259669" aria-label="Call United State and Canada support at 800 225 9669">800-225-9669</a>')
        .replace('+1 801-975-8100', '<a href="tel:+18019758100" aria-label="Call international support at plus 1 801 975 8100" >+1 801-975-8100</a>');
});